import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, MenuItem, Typography } from "@mui/material"
import { type FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { STOCK_TYPES } from "../constants"

import { FormMultiSelect } from "@/components/UiKit/FormControls/FormMultiSelect"
import { type ProductCreateInput } from "@/graphql/codegen/graphql"
import { useLookupWarehouses } from "@/hooks/useLookupWarehouses"
import { SelectComponent } from "@/screens/Products/components/ProductSpecificsForm"
import type { Option } from "@/types/form-fields"

export const ProductConditionsContent: FC = () => {
  const { control, watch } = useFormContext<ProductCreateInput>()
  const { warehouses } = useLookupWarehouses()

  const warehouseOptions: Option<string>[] = warehouses.map(({ id, label }) => ({
    value: id,
    label: label,
  }))

  const renderStockTypeValue = (value: string | undefined) => {
    if (!value) {
      return <span className='text-gray-500'>Select One</span>
    }

    const selectedOption = STOCK_TYPES.find((option) => option.value === value)
    return selectedOption ? selectedOption.label : value
  }

  return (
    <form>
      <Box>
        <FormMultiSelect
          control={control}
          name='warehouseAreaIds'
          label='Assigned Warehouses'
          options={warehouseOptions}
          placeholder='Select warehouses'
        />
        <Box className='mt-6'>
          <SelectComponent
            name='stockType'
            control={control}
            label='Stock'
            placeholder='Select One'
            hasClearButton
            renderValue={renderStockTypeValue}
          >
            {STOCK_TYPES.map(({ label, value }) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </SelectComponent>
        </Box>
        <FormControl component='fieldset' variant='standard' className='mt-[27px]'>
          <Typography fontWeight='normal' className='mb-4 text-gray-800'>
            Select other relevant conditions for this product
          </Typography>
          <FormGroup>
            <Controller
              name='excludedFromCombinedPricing'
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={watch("excludedFromCombinedPricing") ?? false}
                      onChange={(event) => field.onChange(event.target.checked)}
                      name='excludedFromCombinedPricing'
                    />
                  }
                  className='mb-1'
                  label='Excluded From Combined Pricing'
                />
              )}
            />
            <Controller
              name='isOnAllocation'
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={watch("isOnAllocation") ?? false}
                      onChange={(event) => field.onChange(event.target.checked)}
                      name='isOnAllocation'
                    />
                  }
                  className='mb-1'
                  label='On Allocation'
                />
              )}
            />
          </FormGroup>
        </FormControl>
      </Box>
    </form>
  )
}
